import {
  readNotificationPreferences,
  writeNotificationPreferences,
} from 'Pods/ThreeDStudio/Services/notificationPreferencesStorage'

import { threeDStudioStore } from '../index'

/**
 * Seeds the toggles from localStorage. Called after mount rather than from the
 * slice default so nothing reads browser storage during the SSR render of this
 * fast page; both preference surfaces start closed, so the stored values are
 * always in place before either is rendered. No-ops when the stored values
 * already match, keeping repeat calls from every mounted surface free.
 */
export const hydrateNotificationPreferences = () => {
  const stored = readNotificationPreferences()
  const current = threeDStudioStore.getState().notificationPreferences

  if (stored.emailWhenReady === current.emailWhenReady
    && stored.browserNotifications === current.browserNotifications) {
    return
  }

  threeDStudioStore.setState({ notificationPreferences: stored })
}

/**
 * Merges a toggle change into the shared preferences and persists it. Both
 * surfaces (first-generation popover, Settings modal) are mounted at once, so
 * they patch one store entry: with a copy per surface the longer-lived popover
 * wrote its stale value back over whatever the modal had just persisted.
 * @param {Object} patch - Partial preferences (e.g. { emailWhenReady: true })
 */
export const patchNotificationPreferences = (patch) => {
  const next = { ...threeDStudioStore.getState().notificationPreferences, ...patch }

  writeNotificationPreferences(next)
  threeDStudioStore.setState({ notificationPreferences: next })
}
